import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardTitle } from 'reactstrap';
import styled from 'styled-components';
import PasswordResetForm from './PasswordResetForm';
import VoiceProfileForm from './VoiceProfileForm';
import {
  updatePassword,
  updateVoiceProfile,
  fetchVoiceProfile,
} from '../actions';
import BlockUi from 'react-block-ui';

const SettingsContainer = styled.div`
  padding: 20px;
  margin-top: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    margin-top: 1rem;
    padding: 10px;
  }

  @media (max-width: 576px) {
    margin-top: 0.5rem;
    padding: 5px;
  }
`;

class Settings extends Component {
  componentDidMount() {
    this.props.dispatch(fetchVoiceProfile());
  }

  handlePasswordSubmit = (values) => {
    this.props.dispatch(
      updatePassword(values.currentPassword, values.newPassword)
    );
  };

  handleVoiceProfileSubmit = (values) => {
    this.props.dispatch(updateVoiceProfile(values.lang, values.vocabulary));
  };

  render() {
    const { voiceProfile, loading } = this.props;
    return (
      <SettingsContainer className="container">
        <BlockUi blocking={loading}>
          <Card className="mb-4">
            <CardBody>
              <CardTitle tag="h5">Password Reset</CardTitle>
              <PasswordResetForm onSubmit={this.handlePasswordSubmit} />
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <CardTitle tag="h5">Voice Profile</CardTitle>
              <VoiceProfileForm
                onSubmit={this.handleVoiceProfileSubmit}
                initialValues={{
                  lang: voiceProfile?.lang || '',
                  vocabulary: voiceProfile?.vocabulary || [],
                }}
              />
            </CardBody>
          </Card>
        </BlockUi>
      </SettingsContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  voiceProfile: state.settings.voiceProfile,
  loading: state.settings.loading,
});

export default connect(mapStateToProps)(Settings);
